export var convertAvailableStaff = function (dto) { return ({
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    avatar: dto.image,
}); };
export var convertUnavailableStaff = function (dto) { return ({
    id: dto.id,
    name: dto.name,
    avatar: dto.image_url,
}); };
